import { takeEvery, call, put } from 'redux-saga/effects';
import {
  fetchingGroupLocations,
  groupLocationsError,
  receiveGroupLocations,
} from '../actions/groupLocations';
import { apiGetAllPages } from './core';
import { getGroupLocationsUrl } from '../core/dapi/location';

const GET_GROUP_LOCATIONS = 'saga/GET_GROUP_LOCATIONS';

function* getGroupLocations({ groupId }) {
  yield put(fetchingGroupLocations());

  const response = yield call(apiGetAllPages, {
    url: getGroupLocationsUrl(groupId),
  });

  if (response.errors) {
    yield put(groupLocationsError(response.errors));
  } else {
    yield put(receiveGroupLocations(response));
  }
}

function* rootSaga() {
  yield takeEvery(GET_GROUP_LOCATIONS, getGroupLocations);
}

export { GET_GROUP_LOCATIONS, rootSaga as default };
